import useSWR  from "swr"

export default function usePreferences() {
    const { data: preferences, mutate } = useSWR("api/v1/utils/vk-ads/whole-interests/") //useSWR("api/v1/utils/my-target/all-interests/")
    return {
        preferences,
        mutate
    }
}